// Balance Ajax Update

var wbTimeout = false;

function balanceAjaxUpdate() {

    wbTimeout = setTimeout(function () {

        const formData = {
            action: 'bb_account_wallet_balance',
            nonce: ajaxobject.nonce,
        };

        jQuery.post(ajaxobject.ajaxurl, formData, function (response) {

            if (response.success && response.data.balance && response.data.balance > -1) {
                jQuery('.wp-element-button.balance span').html(response.data.balance);
            }

        }, 'json').always(function(){

            wbTimeout = false;
            balanceAjaxUpdate();

        });

    }, 5000);

}

document.addEventListener('DOMContentLoaded', function () {
    if (jQuery('.wp-element-button.balance span').get(0)) {
        balanceAjaxUpdate();
    }
});
